import { Component, OnInit } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

import { RoleModel } from '../../../authentication/models/role.model';
import { RoleService } from '../../../authentication/services/role.service';
import { PluginDataInterface } from '../../../plugins/interfaces/plugin-data.interface';
import { ChassisFormHandler } from '../../../forms/form/classes/form-handler';
import { BUTTONS } from '../../../support/buttons';
import { ToolbarService } from '../../../layouts/toolbar/services/toolbar.service';
import { FormFactory } from '../../../forms/form.services';

@Component({
    selector: 'chassis-users-role-create-page',
    templateUrl: './create.page.html',
    styleUrls: ['./create.page.scss'],
    providers: [RoleService]
})
export class RoleCreatePage implements OnInit {

    /**
     * The ChassisFormHandler form instance.
     */
    public form: ChassisFormHandler;

    /**
     * The RoleModel instance.
     *
     * @type {RoleModel}
     */
    public model: RoleModel = new RoleModel;

    /**
     * The singular form of the model
     *
     * @type {string}
     */
    protected singular = 'role';

    /**
     * The plural form of the model
     *
     * @type {string}
     */
    protected plural = 'roles';

    /**
     * The title of the page
     *
     * @type {string}
     */
    protected title = 'Create ' + this.singular;

    /**
     * The route prefix for the buttons
     *
     * @type {string}
     */
    protected routePrefix = this.plural;

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'chassis-core-role-create';

    /**
     * The subject which determines when the user is loaded.
     */
    protected roleSubject: Subject<RoleModel> = new ReplaySubject(1);

    /**
     * The data to send to the plugin slots
     */
    protected pluginData: PluginDataInterface;

    constructor(
        protected formFactory: FormFactory,
        protected toolbarService: ToolbarService,
        protected roleService: RoleService
    ) {
    }

    public ngOnInit() {
        this.createForm();
        this.changeToolbar();

        this.roleSubject.next(this.model);
        this.roleSubject.complete();

        this.setupPlugins();
    }

    protected createForm() {
        this.model = this.roleService.make();

        this.form = this.formFactory.create('role', this.model);
    }

    protected setupPlugins() {
        this.pluginData = {
            inputs: {
                form: this.form,
                modelSubject: this.roleSubject
            }
        };
    }

    protected changeToolbar() {
        this.toolbarService.remove(BUTTONS.DELETE.NAME);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/roles/create/create.page.ts